import { VideoModal } from './video_modal.js';

/**
 * Provides JS functionality for tracking alert display.
 */
export class TextVideoCTA extends DrupalBehavior {
  onContent(context) {
    context.querySelectorAll('iframe').forEach((iframe) => {
      iframe.addEventListener('load', () => {
        iframe.style.opacity = '1';
      });
    });

    const videoModal = new VideoModal();
    const videos = context.querySelectorAll('.text-video-cta--video-url');
    videoModal.init(videos);
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'text_video_cta',
  TextVideoCTA
);
